import { useMemo } from 'react';

/* Diakriet- en hoofdletterongevoelig, en alleen aan het BEGIN van een woord —
   dezelfde regel als snippetFor in src/search.js: "bon" kleurt "bonnen" en
   "bonprinter", maar niet de drie letters midden in "abonnement". */
const ACCENT: Record<string, string> = {
  a: 'aàáâäã', e: 'eèéêë', i: 'iìíîï', o: 'oòóôöõ', u: 'uùúûü', c: 'cç', n: 'nñ',
};
function pattern(w: string): string {
  return w.replace(/[a-z]/g, (c) => {
    const acc = ACCENT[c];
    return acc ? `[${acc}${acc.toUpperCase()}]` : `[${c}${c.toUpperCase()}]`;
  }).replace(/[^a-zA-Z\[\]àáâäãèéêëìíîïòóôöõùúûüçñÀÁÂÄÃÈÉÊËÌÍÎÏÒÓÔÖÕÙÚÛÜÇÑ0-9]/g, (ch) => `\\${ch}`);
}

export function hitRegex(hits: string[] | undefined | null): RegExp | null {
  const woorden = (hits ?? []).filter((h) => h.length >= 3);
  if (!woorden.length) return null;
  // Langste eerst, anders wint "pin" van "retourpinnen".
  woorden.sort((a, b) => b.length - a.length);
  try {
    return new RegExp(`(?<![\\p{L}\\p{N}])(${woorden.map(pattern).join('|')})`, 'gu');
  } catch {
    return null;
  }
}

/** Tekst met de zoekwoorden gemarkeerd. Een <mark> en geen kleur alleen: de
 *  markering heeft een eigen rol in de boom, dus een schermlezer kan hem
 *  benoemen, en print.css kan hem apart behandelen. */
export function Mark({ text, hits, className }: { text: string; hits?: string[] | null; className?: string }) {
  const re = useMemo(() => hitRegex(hits), [hits]);
  if (!re || !text) return <>{text}</>;
  const delen: React.ReactNode[] = [];
  let laatst = 0;
  let i = 0;
  for (const m of text.matchAll(re)) {
    const start = m.index ?? 0;
    if (start > laatst) delen.push(text.slice(laatst, start));
    delen.push(<mark key={i++} className={className ?? 'kb-hit'}>{m[0]}</mark>);
    laatst = start + m[0].length;
  }
  if (laatst < text.length) delen.push(text.slice(laatst));
  return <>{delen}</>;
}
